import React from 'react';
import { Fab, Tooltip } from '@mui/material';
import styles from './FloatingAiIcon.module.scss';
import AIIcon from '../../../../../assets/svgs/AI-Icon.svg';

const FloatingAiIcon = ({ onClick, disabled = false }) => {
    return (
        <div className={styles.floatingContainer}>
            <Tooltip title="Open AI Assistant" placement="left">
                <Fab
                    color="primary"
                    size="medium"
                    onClick={onClick}
                    disabled={disabled}
                    className={styles.floatingButton}
                >
                    <AIIcon />
                </Fab>
            </Tooltip>
        </div>
    );
};

export default FloatingAiIcon;
